<template>
  <v-list-item 
   :class="{ 'no-click': !shouldRipple }"
  @click="handleClick" 


  >
    <v-list-item-title
      class="text-left black--text subtitle-1 font-weight-bold"
    >{{ label }}
    </v-list-item-title>
    <v-list-item-subtitle
     :class="styleclass"
      class="text-right black--text subtitle-1 font-weight-bold"
    >{{ value }}
    </v-list-item-subtitle>
  </v-list-item>
</template>

<script>
export default {
  props: {
    label: String,
    value: null,
    styleclass: String,
    action: {
      type: Function,
      default: () => {
       
      }
    },
  },
  computed: {
    shouldRipple() {
    return !!this.$listeners['list-click'];
  },
  cursorStyle() {
    return this.$listeners['list-click'] ? 'pointer' : 'default';
  }
},
  methods: {
    handleClick() {
      if (this.$listeners['list-click']) {
        this.$emit('list-click');
      } else return null
    }
  }
};
</script>

<style scoped>
.no-click {
  pointer-events: none; 
  background-color: transparent !important; 
}
</style>
